import { Button } from "@/styles/ui/button";
import React from "react";
import { useNavigate } from "react-router-dom";

interface LoginLeftPanelProps {
  children: React.ReactNode;
}

export const LoginLeftPanel: React.FC<LoginLeftPanelProps> = ({ children }) => {
  const navigate = useNavigate();
  return (
    <div className="w-1/2 grow h-full bg-white flex flex-col gap-4 p-10">
      <Button
        className="h-6 relative w-[142px]"
        variant="ghost"
        onClick={() => navigate("/login")}
        type="button"
      >
        <div className="h-6 relative w-[142px]">
          <div className="absolute h-[13.581px] left-0 top-[3.276px] w-[72.354px]">
            <img
              alt=""
              className="block max-w-none size-full"
              src="/login-assets/invector-logo.svg"
            />
          </div>
          <div className="absolute font-['Castoro'] italic leading-[0] left-[107.573px] text-[16.552px] text-blue-500 text-center text-nowrap top-0 tracking-[-0.0033px] translate-x-[-50%]">
            <p className="adjustLetterSpacing block leading-[1.445] whitespace-pre">
              for XBRL
            </p>
          </div>
        </div>
      </Button>
      <div className="flex-1 flex items-center justify-center">
        <div className="flex flex-col gap-6 w-full max-w-[374px]">
          {children}
        </div>
      </div>
    </div>
  );
};
